import React, { useEffect, useState } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import product from "../../images/no-image.jpg";
import { listService } from "../../../service/cms/cms";
import { useNavigate } from "react-router-dom";

const Service = () => {
  const [serviceList, setServiceList] = useState([]);
  const navigate = useNavigate();
  const _FETCH_LIST_SERVICE = async () => {
    try {
      let res = await listService();
      console.log(res.data.data, "resData");
      setServiceList(res.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    _FETCH_LIST_SERVICE();
  }, []);
  const _Navigate_conntact_us = (e) => {
    e.preventDefault();
    navigate("/contactus");
  };
  return (
    <div
      className={
        localStorage.getItem("gs3_AuthToken")
          ? "container-fluid"
          : "container-fluid aboutMain"
      }
    >
      {/* <span className='logo'><img src={Logo} alt='' /></span> */}
      <div className="dbMain">
        <Leftpanel />
        <div className="dbRight">
          <Header link="#" breadcm="" title="Service" description="" />
          <div className="commonBase">
            <div className="serviceBase">
              {localStorage.getItem("gs3_AuthToken") ? (
                ""
              ) : (
                <h2 className="text-center pb-4">Service</h2>
              )}
              {serviceList.length > 0 &&
                serviceList.map((item, index) => {
                  return (
                    <div className="serviceCard">
                      <div className="row">
                        <div
                          className={
                            index % 2 === 0
                              ? "col-xl-2 col-lg-4"
                              : "col-xl-2 col-lg-4 order-lg-2"
                          }
                        >
                          <img
                            src={
                              item.img
                                ? `https://nodeserver.mydevfactory.com:8000/uploads/customer/${item.img}`
                                : product
                            }
                            alt=""
                          />
                        </div>
                        <div
                          className={
                            index % 2 === 0
                              ? "col-xl-10 col-lg-8"
                              : "col-xl-10 col-lg-8 order-lg-1"
                          }
                        >
                          <h3>{item.title}</h3>
                          <div
                            dangerouslySetInnerHTML={{ __html: item.text }}
                          />
                          <button
                            className="commonButton"
                            style={{ float: index % 2 === 0 ? "right" : "" }}
                            onClick={(e) => _Navigate_conntact_us(e)}
                          >
                            Contact Us
                          </button>
                          {/* <a href='' className=''>More...</a> */}
                        </div>
                      </div>
                    </div>
                  );
                })}

              {/* <div className='serviceCard'>
                                <div className='row'>
                                    <div className='col-xl-2 col-lg-4 order-lg-2'><img src={product} alt='' /></div>
                                    <div className='col-xl-10 col-lg-8 order-lg-1'>
                                        <h3>Heading</h3>
                                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsa, vel harum, est reprehenderit placeat rem aperiam magni recusandae dolorum ad perferendis illo saepe neque similique suscipit corrupti? Tempora ullam maiores amet odit adipisci libero earum est ducimus facilis. Accusamus officia quod facere corporis reiciendis molestiae, eaque alias minus veritatis cum.</p>
                                        <button className='commonButton'>Contact Us</button>
                                       
                                    </div>
                                </div>
                            </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
